export class PartySizeDurationDTO {
    constructor(
        public partySize: number | null,
        public duration: number
    ) { }
}
